import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Runner } from '@pixi/runner';
var TransformFeedback = /*#__PURE__*/function () {
  function TransformFeedback() {
    _classCallCheck(this, TransformFeedback);
    this._glTransformFeedbacks = {};
    this.buffers = [];
    this.disposeRunner = new Runner("disposeTransformFeedback");
  }
  _createClass(TransformFeedback, [{
    key: "bindBuffer",
    value: function bindBuffer(index, buffer) {
      this.buffers[index] = buffer;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.disposeRunner.emit(this, false);
    }
  }]);
  return TransformFeedback;
}();
export { TransformFeedback };